import { Skill, SkillTag } from './SkillTag'

export const TagGroup = ({ skills, showAll = false }: { skills: Skill[]; showAll?: boolean }) => (
  <div className="flex flex-wrap gap-y-2 gap-x-2">
    {showAll ? (
      <>
        {skills.map(skill => (
          <SkillTag key={skill.id} skill={skill} type="SKILL" />
        ))}
      </>
    ) : (
      <>
        <SkillTag skill={skills[0]} type="SKILL" />
        {skills.length > 1 && <SkillTag skill={{ name: `+${skills.length - 1}`, color: '#D7D7D7' }} type="SKILL" />}
      </>
    )}
  </div>
)
